export const photos = [
  { id: 4, title: "heavy clouds-min", img: "/img/photos/heavy_clouds-min.jpg" },
  { id: 8, title: "ubc evening-min", img: "img/photos/ubc_evening-min.jpg" },

  { id: 2, title: "go vegan-min", img: "/img/photos/go_vegan-min.jpg" },
  { id: 3, title: "going home-min", img: "/img/photos/going_home-min.jpg" },
  {
    id: 5,
    title: "shadowy sunset-min",
    img: "img/photos/shadowy_sunset-min.jpg",
  },
  {
    id: 7,
    title: "toronto lights-min",
    img: "img/photos/toronto_lights-min.jpg",
  },
  { id: 6, title: "single cloud-min", img: "img/photos/single_cloud-min.jpg" },
  { id: 1, title: "dawg-min", img: "/img/photos/dawg-min.jpg" },
  
  {
    id: 9,
    title: "velvet commute-min",
    img: "img/photos/velvet_commute-min.jpg",
  },

  { id: 10, title: "shiny night-min", img: "img/photos/shiny_night-min.jpg" },

];
